<template>
  <div class="summary_module">
    <el-row>
      <el-col :span="4">&nbsp;</el-col>
      <el-col :span="8">
        <video width="100%" height="100%" controls ref="video">
        </video>
      </el-col>
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="8">
        <div class="h_summary_title">
          <span class="enMainTitle">{{summaryTitle}} </span>
        </div>
        <p class="chapter_text" v-html="briefSummary"></p>
        <el-button class="enmore_btn " @click="seeMore">
          more<i class="el-icon-right  el-icon--right"></i>
        </el-button>
      </el-col>
      <el-col :span="3">&nbsp;</el-col>
    </el-row>
  </div>
</template>
<script>
import { companySummaryInfos } from '@/api/enFrontApi/company';
export default {
  data() {
    return {
      movieSrc: '',
      summaryTitle: 'About IAIC',
      subTitle1: 'Company',
      subTitle2: 'Profile',
      briefSummary: ''
    };
  },
  created() {
    this.getMovie();
    this.getSummary();
  },
  methods: {
    getContent(content) {
      let reg = /<\/?.+?\/?>/g;
      return content.replace(reg, '');
    },
    getMovie() {
      companySummaryInfos({ companyOrder: 1 }).then(res => {
        this.$refs.video.src = res.data.companyBody;
      });
    },
    getSummary() {
      companySummaryInfos({ companyOrder: 2 }).then(res => {
        this.briefSummary = res.data.companyBody;
      });
    },
    seeMore() {
      this.$router.push({
        name: 'iaic2019en/company',
        params: {
          sumType: 1
        }
      });
    }
  }
};
</script>
<style scoped>
.summary_module {
  width: 100%;
  height: 100%;
  background-image: url('../../../../static/img/syscom/bkg-com.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 20px 0;
}
.h_summary_title {
  height: 40px;
}
.chapter_text {
  text-indent: 2em;
  line-height: 30px;
  color: #000;
  width: 100%;
  /* height: 80%; */
  height: 235px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 8; /*第10行显示 ...*/
  -webkit-box-orient: vertical;
}
.more_btn_cup {
  width: 100%;
  text-align: center;
}
.enmore_btn {
  background: rgba(223, 238, 242, 0.5);
}
.enmore_btn:hover {
  background-color: #00697f;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/home/homeSummary.vue